export const STREAMLAIN_APP_TOPBAR_HEIGHT = 52;

export const STREAMLAIN_TWO_PANE_OVERLAY_QUERY = '(max-width: 960px)';
export const STREAMLAIN_THREE_PANE_COMPACT_QUERY = '(max-width: 820px)';
